import React, { useState } from 'react';
import Header from '../components/Header';
import MonacoCsvEditor from '../components/MonacoCsvEditor';
import Footer from '../components/Footer';
const CsvEditor = ({cookieConsent, setCookieConsent}) => {
  const [value, setValue] = useState('header1,header2\nvalue1,value2');

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  const styles = {
    container: {
      paddingBottom: "100px",
      paddingTop: "100px",
      minHeight: "100vh",
      position: "relative",
    },
  };

  return (
    <div style={styles.container}>
      <Header />
      <div style={styles.mainContainer}>
        <div style={styles.inputContainer}>
          <h2>CSV入力</h2>
          <div style={styles.editorContainer}>
            <MonacoCsvEditor value={value} onChange={handleChange} disabled={cookieConsent !== 'accepted'} />
          </div>
        </div>
      </div>
      <Footer cookieConsent={cookieConsent} setCookieConsent={setCookieConsent} />
    </div>
  );
};

export default CsvEditor;
